exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-11006298] {\n  margin: 16px 0 0 0;\n}\ninput[type=\"number\"][data-v-11006298] {\n  margin: 15px 30px 20px 2px;\n}\n@media (max-width: 500px) {\ninput[data-v-11006298] {\n    width: 80%;\n}\n}\n", ""]);

// exports
